import { render, staticRenderFns } from "./terms-and-conditions.vue?vue&type=template&id=37ce2d42&scoped=true"
import script from "./terms-and-conditions.vue?vue&type=script&lang=js"
export * from "./terms-and-conditions.vue?vue&type=script&lang=js"
import style0 from "./terms-and-conditions.vue?vue&type=style&index=0&id=37ce2d42&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ce2d42",
  null
  
)

export default component.exports